import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { notAllowedMenuItems, apisDataCacheKeys, homeRoute } from '@app-constants/app.constants';
import { AuthService } from '@app-services/auth-service/auth.service';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
// import { AuthService } from '@app-core/components/auth-service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public auth: AuthService,
              public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {
    const token: any = localStorage.getItem('token');
    if (!token) {
      this.auth.updateAuthStatus(false);
      navigateBetweenProjects(this.router, homeRoute + '?returnUrl='+state?.url, route);
      //this.router.navigate(['home'], { queryParams: { returnUrl: state?.url } });
      return false;
    } else {
      this.auth.updateAuthStatus(true);
      let userDetails = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
      const profilePhoto = userDetails['profilePhoto'] || localStorage.getItem('profileImageUrl');
      
      this.auth.setPhoto(profilePhoto);
      let grade = userDetails?.grade?.name?.replace(/[^0-9]/g, '');
      if(grade < 9 ){
          
          const targetExamName = localStorage.getItem('targetExamName');
          let splittedUrl = state.url.split('/')
          if((grade ==1 || grade ==2) && state.url=='/dashboard'){
            this.router.navigate(['/dashboard/assessment'])
          }

          
          else if( splittedUrl?.[2]){
      return        ( notAllowedMenuItems[grade][targetExamName]?.indexOf(splittedUrl?.[2]) == -1) ? true : false
          }else if(splittedUrl?.[1] =='dashboard'){
              return true
          }
          // return true
      }else{
        return true;
      }
      // let userGrade = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
      // if (userGrade?.grade?.name && userGrade?.grade?.name?.substring(0, 2) == '10' && state?.url !== "/myprofile") {
      
      // } else {    
      //   return true;
      // }
    }
  }

}
